<template>
  <div>
    <Loading :loading="sending || !user" />
    <!-- SENHA para editar -->
    <form
      v-if="!sending && user"
      novalidate
      @submit.prevent="handleSubmitChangeSenha"
    >
      <md-card-content>
        <p class="md-title">Mudar senha do usuário: {{ user.userName }}</p>
        <p class="md-subhead">Nome completo: {{ user.nomeCompleto }}</p>
        <p class="md-subhead">Email: {{ user.email }}</p>
      </md-card-content>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationNewPassword('password')">
              <label for="password">Nova senha</label>
              <md-input
                id="password"
                v-model="changePassword.password"
                name="password"
                type="password"
                :disabled="sending"
              />
              <span v-if="!$v.changePassword.password.required" class="md-error"
                >Senha é obrigatório</span
              >
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationNewPassword('confirmPassword')">
              <label for="confirmPassword">Confirmar nova senha</label>
              <md-input
                id="confirmPassword"
                v-model="changePassword.confirmPassword"
                name="confirmPassword"
                type="password"
                :disabled="sending"
              />
              <span
                v-if="!$v.changePassword.confirmPassword.required"
                class="md-error"
                >Confirmar Senha é obrigatório</span
              >
              <span
                v-if="!$v.changePassword.confirmPassword.sameAsPassword"
                class="md-error"
              >
                A confirmação de senha é inválida
              </span>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-switch v-model="changePassword.deveMudarSenha">
              Deve Mudar senha após Login
            </md-switch>
          </div>

          <md-divider />
        </div>
      </md-card-content>

      <md-progress-bar v-if="sending" md-mode="indeterminate" />

      <md-card-actions>
        <md-button type="submit" class="md-primary" :disabled="sending">
          Mudar senha
        </md-button>
      </md-card-actions>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'

import Loading from '../../components/Loading'
import http from '../../utils/http'

export default {
  name: 'UsuarioTrocarSenha',
  components: { Loading },
  mixins: [validationMixin],
  data() {
    return {
      userId: null,
      changePassword: {
        password: null,
        confirmPassword: null,
        deveMudarSenha: true,
      },
      user: null,
      sending: false,
    }
  },
  validations: {
    changePassword: {
      password: {
        required,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  async mounted() {
    this.userId = this.$route.params.userId

    this.user = await http.get('accounts/user/' + this.userId)
  },
  methods: {
    async handleSubmitChangeSenha() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.sending = true

      const data = await http.put('accounts/user/password', {
        password: this.changePassword.password,
        confirmPassword: this.changePassword.confirmPassword,
        userId: this.userId,
        deveTrocarAposLogin: this.changePassword.deveMudarSenha,
      })

      this.sending = false

      if (data) {
        await this.$router.push({ name: 'usuarios' })
      }
    },
    getValidationNewPassword(fieldName) {
      const field = this.$v.changePassword[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
